<template>
    <div class="tw-inline">
        <span
           :title="canDeleteWorkTime ? 'Löschen' : 'Löschantrag erstellen'"
           :class="buttonClasses"
           @click="handleDelete"
        >
            <span class="glyphicon glyphicon-trash" aria-hidden="true"></span>
        </span>
    </div>
</template>

<script>
export default {
    props: {
        workTime: {
            required: true,
            type: Object,
        },

        canDeleteWorkTime: {
            required: true,
            type: Boolean,
        },

        buttonClasses: {
            required: false,
            type: String,
            default: 'cu-btn-default-sm',
        }
    },

    methods: {
        handleDelete() {
            if (this.canDeleteWorkTime) {
                window.location.href = `/worktime/delete/${this.workTime.id}`;
            } else {
                try {
                    this.showExplanationDialog();
                } catch (e) {
                    window.location.href = `/worktime/delete/${this.workTime.id}`;
                }
            }
        },

        showExplanationDialog() {
            Swal.fire({
                title: 'Bitte gib eine Begründung ein',
                input: 'textarea',
                inputAttributes: {
                    autocapitalize: 'off'
                },
                showCancelButton: true,
                confirmButtonText: 'Löschen',
                showLoaderOnConfirm: true,
                preConfirm: (inputValue) => {
                    if (! inputValue || inputValue.length === 0) {
                        Swal.showValidationMessage(`Bitte Begründung eingeben`);
                    }
                }
            }).then((result) => {
                if (result.isConfirmed) {
                    window.location.href = `/worktime/delete/${this.workTime.id}?explanation=${encodeURIComponent(result.value)}`;
                }
            });
        }
    }
}
</script>
